/**
 * 搜索表单逻辑管理 Hook
 */
import { useState } from 'react';
import { FormInstance } from 'antd';
import { iAllDriverRegistrationInfoRequest } from '@/service/driverArchive/define';

export const useSearchForm = (form: FormInstance) => {
  const [searchParams, setSearchParams] = useState<iAllDriverRegistrationInfoRequest>({});

  // 搜索
  const onSearch = (values: any) => {
    const params: iAllDriverRegistrationInfoRequest = {
      reviewStat: values.reviewStatus,
      name: values.driverName,
      companyId: values.fleetId,
    };
    setSearchParams(params);
  };

  // 重置
  const onReset = () => {
    form.resetFields();
    setSearchParams({});
  };

  // 导出参数
  const getExportParams = async () => {
    return {
      ...searchParams,
      export: true,
    };
  };

  return {
    searchParams,
    onSearch,
    onReset,
    getExportParams,
  };
};
